import React from "react";
import LoanSection from "./LoanSection";
import "./LoanScroll.css";

import homeBg from "./assets/images/FrontPage/home_bg.png";
import lapBg from "./assets/images/FrontPage/lap_bg.png";
import eduBg from "./assets/images/FrontPage/education_bg.png";
import busBg from "./assets/images/FrontPage/business_bg.png";
import perBg from "./assets/images/FrontPage/personal_bg.png";
import carBg from "./assets/images/FrontPage/car_bg.png";

import mobhome from "./assets/images/FrontPage/mobile-home-loan.jpg";
import moblap from "./assets/images/FrontPage/mobile-loan-against-property.jpg";
import mobedu from "./assets/images/FrontPage/mob-education.png";
import mobper from "./assets/images/FrontPage/mobilepersonalloan.png";
import mobcar from "./assets/images/FrontPage/mobilecarloan.jpg";
import mobbus from "./assets/images/FrontPage/mobilebusinessloan.png";

import homeCircle from "./assets/images/FrontPage/homeloancircle.png";
import lapCircle from "./assets/images/FrontPage/loanagainstpropertycircle.png";
import eduCircle from "./assets/images/FrontPage/educationloancircle.png";
import busCircle from "./assets/images/FrontPage/businessloancircle.png";
import perCircle from "./assets/images/FrontPage/personalloancircle.png";
import carCircle from "./assets/images/FrontPage/car-loan-infograph.png";

const sections = [
  {
    id: "home-loan",
    label: "Home Loan",
    desktopBg: homeBg,
    mobileBg: mobhome,
    heading: "Home Loans Starting At",
    highlight: "7.10%*",
    imgSrc: homeCircle,
    imageAlt: "Home loan financing illustration",
    applyLabel: "Apply for Home Loan",
    features: [
      {
        icon: "bi bi-bank",
        text: "Loan options from leading public sector banks",
      },
      {
        icon: "bi bi-wallet2",
        text: "Flexible EMI options tailored to your financial needs",
      },
      {
        icon: "bi bi-percent",
        text: "Competitive home loan interest rates in Pune",
      },
      {
        icon: "bi bi-file-earmark-check",
        text: "Zero processing fees on selected bank offers",
      },
      {
        icon: "bi bi-house-check",
        text: "End-to-end doorstep assistance",
      },
      {
        icon: "bi bi-people",
        text: "Business associate partner of leading banks",
      },
    ],
  },

  {
    id: "loan-against-property",
    label: "Loan Against Property",
    desktopBg: lapBg,
    mobileBg: moblap,
    heading: "Loan Against Property Starting At",
    highlight: "7.90%*",
    imgSrc: lapCircle,
    imageAlt: "Loan against property illustration",
    applyLabel: "Apply for Property Loan",
    features: [
      {
        icon: "bi bi-building-check",
        text: "High-value funding against residential or commercial property",
      },
      {
        icon: "bi bi-percent",
        text: "Attractive interest rates starting from 7.90%*",
      },
      {
        icon: "bi bi-lightning-charge",
        text: "Quick application processing and disbursal support",
      },
      {
        icon: "bi bi-house-door",
        text: "Doorstep assistance throughout the loan process",
      },
      {
        icon: "bi bi-award",
        text: "Trusted mortgage loan assistance in Pune",
      },
    ],
  },

  {
    id: "education-loan",
    label: "Education Loan",
    desktopBg: eduBg,
    mobileBg: mobedu,
    heading: "Education Loans Starting At",
    highlight: "9.99%*",
    imgSrc: eduCircle,
    imageAlt: "Education loan illustration",
    applyLabel: "Apply for Education Loan",
    features: [
      {
        icon: "bi bi-mortarboard",
        text: "Simple education loan application assistance",
      },
      {
        icon: "bi bi-bank",
        text: "Loan options from leading public sector banks",
      },
      {
        icon: "bi bi-globe2",
        text: "Funding support for studies in India and abroad",
      },
      {
        icon: "bi bi-percent",
        text: "Competitive interest rates based on your profile",
      },
      {
        icon: "bi bi-laptop",
        text: "Online application with doorstep document assistance",
      },
    ],
  },

  {
    id: "business-loan",
    label: "Business Loan",
    desktopBg: busBg,
    mobileBg: mobbus,
    heading: "Business Loans Starting At",
    highlight: "9.00%*",
    imgSrc: busCircle,
    imageAlt: "Business loan growth illustration",
    applyLabel: "Apply for Business Loan",
    features: [
      {
        icon: "bi bi-briefcase",
        text: "Funding options for business expansion and working capital",
      },
      {
        icon: "bi bi-cash-stack",
        text: "Loan solutions for inventory, equipment and operations",
      },
      {
        icon: "bi bi-percent",
        text: "Competitive interest rates based on business eligibility",
      },
      {
        icon: "bi bi-file-earmark-text",
        text: "Assistance with documentation and lender comparison",
      },
      {
        icon: "bi bi-graph-up-arrow",
        text: "Flexible funding options for growing businesses",
      },
      {
        icon: "bi bi-house-door",
        text: "Online application with doorstep assistance",
      },
    ],
  },

  {
    id: "personal-loan",
    label: "Personal Loan",
    desktopBg: perBg,
    mobileBg: mobper,
    heading: "Personal Loans Starting At",
    highlight: "9.99%*",
    imgSrc: perCircle,
    imageAlt: "Personal loan illustration",
    applyLabel: "Apply for Personal Loan",
    features: [
      {
        icon: "bi bi-lightning-charge",
        text: "Fast personal loan application processing",
      },
      {
        icon: "bi bi-file-earmark-check",
        text: "Minimal documentation for eligible applicants",
      },
      {
        icon: "bi bi-clock-history",
        text: "Quick approval and disbursal assistance",
      },
      {
        icon: "bi bi-bank",
        text: "Compare offers from leading banks and lenders",
      },
      {
        icon: "bi bi-house-door",
        text: "Online application with doorstep service",
      },
    ],
  },

  {
    id: "car-loan",
    label: "Car Loan",
    desktopBg: carBg,
    mobileBg: mobcar,
    heading: "Car Loans Starting At",
    highlight: "7.45%*",
    imgSrc: carCircle,
    imageAlt: "Car loan financing illustration",
    applyLabel: "Apply for Car Loan",
    features: [
      {
        icon: "bi bi-car-front",
        text: "Easy car loan application assistance",
      },
      {
        icon: "bi bi-bank",
        text: "Offers from leading public and private sector banks",
      },
      {
        icon: "bi bi-percent",
        text: "Attractive interest rates starting from 7.45%*",
      },
      {
        icon: "bi bi-patch-check",
        text: "Loan options selected according to your eligibility",
      },
      {
        icon: "bi bi-speedometer2",
        text: "Quick approval and fast disbursal assistance",
      },
      {
        icon: "bi bi-house-door",
        text: "Apply online with doorstep service in Pune",
      },
    ],
  },
];

export default function LoanSectionsWrapper() {
  return (
    <section
      className="loan-showcase"
      aria-label="Monayra loan products"
    >
      <div className="loan-showcase-heading">
        <span className="loan-showcase-eyebrow">
          Explore Our Loan Solutions
        </span>

        <h2>
          Financial solutions designed around
          <span> your goals</span>
        </h2>

        <p>
          Compare suitable loan options and receive complete assistance
          from application to disbursement.
        </p>
      </div>

      <div className="loan-sections-stack">
        {sections.map((section, index) => (
          <LoanSection
            key={section.id}
            sectionNumber={index + 1}
            label={section.label}
            desktopBg={section.desktopBg}
            mobileBg={section.mobileBg}
            heading={section.heading}
            highlight={section.highlight}
            imgSrc={section.imgSrc}
            imageAlt={section.imageAlt}
            applyLabel={section.applyLabel}
            features={section.features}
          />
        ))}
      </div>

      <div className="loan-rate-disclaimer">
        <i className="bi bi-info-circle"></i>

        <p>
          *Interest rates are indicative and may vary according to the
          applicant’s profile, credit score, lender policies and prevailing
          market conditions.
        </p>
      </div>
    </section>
  );
}